
import dayjs from "dayjs";


export function parseVisitDate(value) {
  if (!value) return null;

  // Already a dayjs object
  if (dayjs.isDayjs(value)) return value;

  // Number or numeric string — treat as Unix seconds if ≤ 10 digits
  const num = typeof value === "string" ? Number(value) : value;
  if (!isNaN(num) && String(value).trim().match(/^\d+$/)) {
    // Epoch seconds → multiply by 1000 for dayjs
    return num > 9_999_999_999
      ? dayjs(num)           // already ms
      : dayjs(num * 1000);   // seconds → ms
  }

  // ISO string / PG timestamp string
  return dayjs(value);
}


export function formatVisitDate(value, fmt = "ddd, MMM D YYYY") {
  const d = parseVisitDate(value);
  return d?.isValid() ? d.format(fmt) : "—";
}


export function formatVisitTime(value, fmt = "h:mm A") {
  const d = parseVisitDate(value);
  return d?.isValid() ? d.format(fmt) : "";
}


export function fromNowVisit(value) {
  const d = parseVisitDate(value);
  return d?.isValid() ? d.fromNow() : "";
}


export function visitDateParts(value) {
  const d = parseVisitDate(value);
  if (!d?.isValid()) return { dayNum: "?", month: "???" };
  return {
    dayNum: d.format("D"),
    month:  d.format("MMM").toUpperCase(),
  };
}